import React from "react";
import Logo from "../../src/images/bcs-logo.png";
import { LogOut } from "lucide-react";
import { signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const NavBar = () => {

    const navigate=useNavigate()
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate("/login");
      toast.success("Signed out successfully");
    } catch (error) {
      toast.error("Error signing out!");
    }
  };

  return (
    <nav className="w-full flex justify-between items-center px-6 py-6 bg-white shadow-md">
      <div>
        <img src={Logo} className="w-full" alt="BCS-LOGO" />
      </div>
      <div className="flex items-center space-x-4">
        <div
          onClick={handleSignOut}
          className="p-2 bg-gray-200 rounded-full cursor-pointer"
        >
          <LogOut size={20} />
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
